// GENERATED by scripts/build-filter-spec.mjs from core/search-filter-spec.json — do not edit; edit the JSON and re-run.
export default {
  "generated": "2026-09-04T23:09:28.935Z",
  "rpc": "search_agent_listing_clusters_v66_slow",
  "units": [
    "scope",
    "cluster",
    "overlay",
    "modifier",
    "member"
  ],
  "plumbing": [
    "p_party_ids",
    "p_since",
    "p_limit",
    "p_offset",
    "p_sort",
    "p_scope",
    "p_lead_statuses",
    "p_comm_rank",
    "p_restriction_policy",
    "p_unknown_limit",
    "p_unknown_offset",
    "p_viewer_party",
    "p_precut",
    "p_status",
    "p_ids_only",
    "p_range_facets"
  ],
  "unassigned": [],
  "filters": [
    {
      "key": "complexIds",
      "kind": "set",
      "layer": "location",
      "label": "desk_facet_complex",
      "client": {
        "state": "complexIds",
        "url": [
          "complexes"
        ],
        "serverOnly": false
      },
      "wire": [
        "complexes"
      ],
      "server": [
        "complex_ids"
      ],
      "rpc": [
        "p_complex_ids"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "complex identity; no panel control existed before this registry",
      "excludeNote": "include-only for now: a search-box pick, not a checkbox facet (B1213 scope)"
    },
    {
      "key": "streetIds",
      "kind": "set",
      "layer": "location",
      "label": "desk_facet_street",
      "client": {
        "state": "streetIds",
        "url": [
          "streets"
        ],
        "serverOnly": false
      },
      "wire": [
        "streets"
      ],
      "server": [
        "street_ids"
      ],
      "rpc": [
        "p_street_ids"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "depends on a picked district; StreetFacetList owns the control",
      "excludeNote": "include-only for now: a search-box pick, not a checkbox facet (B1213 scope)"
    },
    {
      "key": "metroIds",
      "kind": "set",
      "layer": "location",
      "label": "desk_facet_metro",
      "client": {
        "state": "metroIds",
        "url": [
          "metro"
        ],
        "serverOnly": false
      },
      "wire": [
        "metro"
      ],
      "server": [
        "metro_ids"
      ],
      "rpc": [
        "p_metro_ids"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "counts are deliberately district-blind",
      "excludeNote": "include-only for now: a search-box pick, not a checkbox facet (B1213 scope)"
    },
    {
      "key": "balconyCount",
      "kind": "range",
      "layer": "size",
      "label": "desk_facet_balcony_count",
      "client": {
        "state": "balconyCount",
        "url": [
          "balcMin",
          "balcMax"
        ],
        "serverOnly": true
      },
      "wire": [
        "balcony_count_min",
        "balcony_count_max"
      ],
      "server": [
        "balcony_count_min",
        "balcony_count_max"
      ],
      "rpc": [
        "p_balcony_count_min",
        "p_balcony_count_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "pills 1/2/3/4+; zero lives on the feature, not the count"
    },
    {
      "key": "districtCodes",
      "kind": "set",
      "layer": "location",
      "label": "desk_facet_district",
      "client": {
        "state": "districtCodes",
        "url": [
          "district"
        ],
        "serverOnly": false
      },
      "wire": [
        "district_codes"
      ],
      "server": [
        "district_codes"
      ],
      "rpc": [
        "p_district_codes"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "OR across codes; counts overlap by design",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "districtCodesNot",
        "url": [
          "district_not"
        ],
        "wire": [
          "district_codes_not"
        ],
        "rpc": [
          "p_district_codes_not"
        ],
        "unit": "member",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit; 0886: an include that is a STRICT descendant of an excluded code is a CARVE-OUT (its subtree leaves the excluded set) and does not restrict on its own — EXPLICIT_DESCENDANT_INCLUDE_OVERRIDES_ANCESTOR_EXCLUDE"
      }
    },
    {
      "key": "districtOwnCodes",
      "kind": "set",
      "layer": "location",
      "label": "desk_facet_district",
      "client": {
        "state": "districtOwnCodes",
        "url": [
          "district_own"
        ],
        "serverOnly": false
      },
      "wire": [
        "district_own_codes"
      ],
      "server": [
        "district_own_codes"
      ],
      "rpc": [
        "p_district_own_codes"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "the raion own bucket, children excluded",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "districtOwnCodesNot",
        "url": [
          "district_own_not"
        ],
        "wire": [
          "district_own_codes_not"
        ],
        "rpc": [
          "p_district_own_codes_not"
        ],
        "unit": "member",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit; 0886: an own-bucket include under an excluded raion takes back only the raion's own code"
      }
    },
    {
      "key": "subtypes",
      "kind": "set",
      "layer": "identity",
      "label": "desk_facet_subtype",
      "client": {
        "state": "subtypes",
        "url": [
          "subtypes"
        ],
        "serverOnly": true
      },
      "wire": [
        "subtypes"
      ],
      "server": [
        "subtypes"
      ],
      "rpc": [
        "p_subtypes"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "array param; kind is the scalar one",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "subtypesNot",
        "url": [
          "subtypes_not"
        ],
        "wire": [
          "subtypes_not"
        ],
        "rpc": [
          "p_subtypes_not"
        ],
        "unit": "member",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit"
      }
    },
    {
      "key": "sources",
      "kind": "set",
      "layer": "provenance",
      "label": "desk_facet_source",
      "client": {
        "state": "sources",
        "url": [
          "sources"
        ],
        "serverOnly": false
      },
      "wire": [
        "sources"
      ],
      "server": [
        "sources"
      ],
      "rpc": [
        "p_sources"
      ],
      "unit": "cluster",
      "current": false,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "portal of the advert; any member of the cluster",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "sourcesNot",
        "url": [
          "sources_not"
        ],
        "wire": [
          "sources_not"
        ],
        "rpc": [
          "p_sources_not"
        ],
        "unit": "cluster",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit"
      }
    },
    {
      "key": "restrictions",
      "kind": "set",
      "layer": "operational",
      "label": "desk_facet_restrictions",
      "client": {
        "state": "restrictions",
        "url": [
          "restrict"
        ],
        "serverOnly": true
      },
      "wire": [
        "restrictions"
      ],
      "server": [
        "restrictions"
      ],
      "rpc": [
        "p_restrictions"
      ],
      "unit": "cluster",
      "current": false,
      "operator": "polarity",
      "operators": [
        "polarity"
      ],
      "values": null,
      "note": "code:polarity entries; mode resolved server-side"
    },
    {
      "key": "price",
      "kind": "range",
      "layer": "budget",
      "label": "desk_facet_price",
      "client": {
        "state": "price",
        "url": [
          "priceMin",
          "priceMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "price_min",
        "price_max"
      ],
      "server": [
        "price_min",
        "price_max"
      ],
      "rpc": [
        "p_price_min",
        "p_price_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "currency is a separate key and is deliberately still hand-written"
    },
    {
      "key": "ppm",
      "kind": "range",
      "layer": "budget",
      "label": "desk_facet_ppm",
      "client": {
        "state": "ppm",
        "url": [
          "ppmMin",
          "ppmMax"
        ],
        "serverOnly": true
      },
      "wire": [
        "ppm_min",
        "ppm_max"
      ],
      "server": [
        "ppm_min",
        "ppm_max"
      ],
      "rpc": [
        "p_num_sets"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "core 3872 (owner 2026-10-24): price per m², in the price currency. Key of p_num_sets (RPC at 100 arguments); both halves emit the whole band"
    },
    {
      "key": "area",
      "kind": "range",
      "layer": "size",
      "label": "desk_facet_area",
      "client": {
        "state": "area",
        "url": [
          "areaMin",
          "areaMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "area_min",
        "area_max"
      ],
      "server": [
        "area_min",
        "area_max"
      ],
      "rpc": [
        "p_area_min",
        "p_area_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "the BUILDING; landArea is the plot and a different key"
    },
    {
      "key": "landArea",
      "kind": "range",
      "layer": "size",
      "label": "desk_facet_land_area",
      "client": {
        "state": "landArea",
        "url": [
          "landAreaMin",
          "landAreaMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "land_area_min",
        "land_area_max"
      ],
      "server": [
        "land_area_min",
        "land_area_max"
      ],
      "rpc": [
        "p_land_area_min",
        "p_land_area_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "the plot, distinct from area"
    },
    {
      "key": "floor",
      "kind": "range",
      "layer": "size",
      "label": "desk_facet_floor",
      "client": {
        "state": "floor",
        "url": [
          "floorMin",
          "floorMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "floor_min",
        "floor_max"
      ],
      "server": [
        "floor_min",
        "floor_max"
      ],
      "rpc": [
        "p_floor_min",
        "p_floor_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "which floor the flat is on"
    },
    {
      "key": "floorsTotal",
      "kind": "range",
      "layer": "size",
      "label": "desk_facet_floors_total",
      "client": {
        "state": "floorsTotal",
        "url": [
          "floorsTotalMin",
          "floorsTotalMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "floors_total_min",
        "floors_total_max"
      ],
      "server": [
        "floors_total_min",
        "floors_total_max"
      ],
      "rpc": [
        "p_floors_total_min",
        "p_floors_total_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "how many floors the building has"
    },
    {
      "key": "bathrooms",
      "kind": "range",
      "layer": "size",
      "label": "desk_facet_bathrooms",
      "client": {
        "state": "bathrooms",
        "url": [
          "bathMin",
          "bathMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "bathrooms_min",
        "bathrooms_max"
      ],
      "server": [
        "bathrooms_min",
        "bathrooms_max"
      ],
      "rpc": [
        "p_bathrooms_min",
        "p_bathrooms_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "range",
      "operators": [
        "range"
      ],
      "values": null,
      "note": "url keys are abbreviated; wire keys are not"
    },
    {
      "key": "advanceMaxMonths",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_advance",
      "client": {
        "state": "advanceMaxMonths",
        "url": [
          "advanceMax"
        ],
        "serverOnly": true
      },
      "wire": [
        "advance_max_months"
      ],
      "server": [
        "advance_max_months"
      ],
      "rpc": [
        "p_advance_max_months"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "months of advance rent; the move-in pair stays hand-written"
    },
    {
      "key": "topFloor",
      "kind": "flag",
      "layer": "size",
      "label": "desk_facet_top_floor",
      "client": {
        "state": "topFloor",
        "url": [
          "topFloor"
        ],
        "serverOnly": false
      },
      "wire": [
        "top_floor"
      ],
      "server": [
        "top_floor"
      ],
      "rpc": [
        "p_top_floor"
      ],
      "unit": "member",
      "current": true,
      "operator": "flag",
      "operators": [
        "flag",
        "exclude"
      ],
      "values": null,
      "note": "is the flat on the building top floor",
      "exclude": {
        "state": "topFloorNot",
        "url": [
          "topFloorNot"
        ],
        "wire": [
          "top_floor_not"
        ],
        "rpc": [
          "p_floor_flags"
        ],
        "unit": "member",
        "note": "✕ on a flag (owner, 2026-09-05): the flat must NOT be on the top floor; unknown floor/floors_total → unknown (shelf), as the ✓ half; PACKED: Postgres allows 100 arguments and the search has 98, so the three floor halves share p_floor_flags text[] (as p_dates packs the date dimensions) — this half is the value not_top",
        "rpcValue": "not_top"
      }
    },
    {
      "key": "firstFloor",
      "kind": "flag",
      "layer": "size",
      "label": "desk_facet_first_floor",
      "client": {
        "state": "firstFloor",
        "url": [
          "firstFloor"
        ],
        "serverOnly": false
      },
      "wire": [
        "first_floor"
      ],
      "server": [
        "first_floor"
      ],
      "rpc": [
        "p_floor_flags"
      ],
      "unit": "member",
      "current": true,
      "operator": "flag",
      "operators": [
        "flag",
        "exclude"
      ],
      "values": null,
      "note": "is the flat on the first floor (floor = 1; floor null or 0 → unknown, as the range verdicts treat 0); packed into p_floor_flags as the value first",
      "exclude": {
        "state": "firstFloorNot",
        "url": [
          "firstFloorNot"
        ],
        "wire": [
          "first_floor_not"
        ],
        "rpc": [
          "p_floor_flags"
        ],
        "unit": "member",
        "note": "✕: the flat must NOT be on the first floor; unknown floor → unknown; packed into p_floor_flags as the value not_first",
        "rpcValue": "not_first"
      },
      "rpcValue": "first"
    },
    {
      "key": "noDescription",
      "kind": "flag",
      "layer": "quality",
      "label": "desk_facet_no_description",
      "client": {
        "state": "noDescription",
        "url": [
          "noDesc"
        ],
        "serverOnly": false
      },
      "wire": [
        "no_description"
      ],
      "server": [
        "no_description"
      ],
      "rpc": [
        "p_no_description"
      ],
      "unit": "cluster",
      "current": false,
      "operator": "flag",
      "operators": [
        "flag"
      ],
      "values": null,
      "note": "adverts with no description text at all"
    },
    {
      "key": "missingFacts",
      "kind": "flag",
      "layer": "quality",
      "label": "desk_facet_missing_facts",
      "client": {
        "state": "missingFacts",
        "url": [
          "missingFacts"
        ],
        "serverOnly": false
      },
      "wire": [
        "missing_facts"
      ],
      "server": [
        "missing_facts"
      ],
      "rpc": [
        "p_missing_facts"
      ],
      "unit": "cluster",
      "current": false,
      "operator": "flag",
      "operators": [
        "flag"
      ],
      "values": null,
      "note": "adverts missing the facts the card needs"
    },
    {
      "key": "exposureMax",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_exposure",
      "client": {
        "state": "exposureMax",
        "url": [
          "exposureMax"
        ],
        "serverOnly": true
      },
      "wire": [
        "exposure_max"
      ],
      "server": [
        "exposure_max"
      ],
      "rpc": [
        "p_exposure_max"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "at-most rung on the exposure ladder"
    },
    {
      "key": "spread",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_spread",
      "client": {
        "state": "spread",
        "url": [
          "spread"
        ],
        "serverOnly": true
      },
      "wire": [
        "spread"
      ],
      "server": [
        "spread"
      ],
      "rpc": [
        "p_spread_min",
        "p_spread_max"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "how widely the owner has posted it"
    },
    {
      "key": "sellerType",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_seller_type",
      "client": {
        "state": "sellerType",
        "url": [
          "sellerType"
        ],
        "serverOnly": true
      },
      "wire": [
        "seller_type"
      ],
      "server": [
        "seller_type"
      ],
      "rpc": [
        "p_seller_props_min",
        "p_seller_props_max"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "owner or agency, by the contact behind the advert"
    },
    {
      "key": "claimsLt",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_claims",
      "client": {
        "state": "claimsLt",
        "url": [
          "claimsLt"
        ],
        "serverOnly": false
      },
      "wire": [
        "claims_lt"
      ],
      "server": [
        "claims_lt"
      ],
      "rpc": [
        "p_claims_lt"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "fewer than N live claims"
    },
    {
      "key": "claimsGt",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_claims",
      "client": {
        "state": "claimsGt",
        "url": [
          "claimsGt"
        ],
        "serverOnly": false
      },
      "wire": [
        "claims_gt"
      ],
      "server": [
        "claims_gt"
      ],
      "rpc": [
        "p_claims_gt"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "more than N live claims"
    },
    {
      "key": "ageMinDays",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_age",
      "client": {
        "state": "ageMinDays",
        "url": [
          "ageMin"
        ],
        "serverOnly": false
      },
      "wire": [
        "age_min_days"
      ],
      "server": [
        "age_min_days"
      ],
      "rpc": [
        "p_age_min_days"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "url key abbreviated to ageMin; wire key is not"
    },
    {
      "key": "ageMaxDays",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_age",
      "client": {
        "state": "ageMaxDays",
        "url": [
          "ageMax"
        ],
        "serverOnly": false
      },
      "wire": [
        "age_max_days"
      ],
      "server": [
        "age_max_days"
      ],
      "rpc": [
        "p_age_max_days"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "url key abbreviated to ageMax; wire key is not"
    },
    {
      "key": "viewsMin",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_views",
      "client": {
        "state": "viewsMin",
        "url": [
          "viewsMin"
        ],
        "serverOnly": false
      },
      "wire": [
        "views_min"
      ],
      "server": [
        "views_min"
      ],
      "rpc": [
        "p_views_min"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "portal view count floor"
    },
    {
      "key": "promoted",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_promoted",
      "client": {
        "state": "promoted",
        "url": [
          "promoted"
        ],
        "serverOnly": false
      },
      "wire": [
        "promoted"
      ],
      "server": [
        "promoted"
      ],
      "rpc": [
        "p_promoted"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "VIP / promoted placement on the portal"
    },
    {
      "key": "ownerEngaged",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_owner_engaged",
      "client": {
        "state": "ownerEngaged",
        "url": [
          "engaged"
        ],
        "serverOnly": false
      },
      "wire": [
        "owner_engaged"
      ],
      "server": [
        "owner_engaged"
      ],
      "rpc": [
        "p_owner_engaged"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "url key is engaged, not ownerEngaged"
    },
    {
      "key": "reposts",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_reposts",
      "client": {
        "state": "reposts",
        "url": [
          "reposts"
        ],
        "serverOnly": true
      },
      "wire": [
        "reposts"
      ],
      "server": [
        "reposts"
      ],
      "rpc": [
        "p_reposts_min",
        "p_reposts_max"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "how many times we have reposted it"
    },
    {
      "key": "ownerPlatforms",
      "kind": "value",
      "layer": "intelligence",
      "label": "desk_facet_owner_platforms",
      "client": {
        "state": "ownerPlatforms",
        "url": [
          "ownerPlat"
        ],
        "serverOnly": true
      },
      "wire": [
        "owner_platforms"
      ],
      "server": [
        "owner_platforms"
      ],
      "rpc": [
        "p_owner_platforms_min",
        "p_owner_platforms_max"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "url key is ownerPlat; counts ORIGINS, never reshares"
    },
    {
      "key": "photos",
      "kind": "value",
      "layer": "quality",
      "label": "desk_facet_photos",
      "client": {
        "state": "photos",
        "url": [
          "photos"
        ],
        "serverOnly": true
      },
      "wire": [
        "photos"
      ],
      "server": [
        "photos"
      ],
      "rpc": [
        "p_photos_min",
        "p_photos_max"
      ],
      "unit": "cluster",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "how many photographs the advert carries"
    },
    {
      "key": "footprint",
      "kind": "set",
      "layer": "intelligence",
      "label": "desk_facet_footprint",
      "client": {
        "state": "footprint",
        "url": [
          "footprint"
        ],
        "serverOnly": false
      },
      "wire": [
        "footprint"
      ],
      "server": [
        "footprint"
      ],
      "rpc": [
        "p_footprint"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "where the owner has posted; a set, not a scalar",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "footprintNot",
        "url": [
          "footprint_not"
        ],
        "wire": [
          "footprint_not"
        ],
        "rpc": [
          "p_footprint_not"
        ],
        "unit": "overlay",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit"
      }
    },
    {
      "key": "currency",
      "kind": "value",
      "layer": "budget",
      "label": "desk_facet_currency",
      "client": {
        "state": "currency",
        "url": [
          "currency"
        ],
        "serverOnly": false
      },
      "wire": [
        "currency"
      ],
      "server": [
        "currency"
      ],
      "rpc": [
        "p_currency"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "only alongside a price bound"
    },
    {
      "key": "moveInHard",
      "kind": "flag",
      "layer": "operational",
      "label": "desk_facet_move_in_hard",
      "client": {
        "state": "moveInHard",
        "url": [
          "moveInHard"
        ],
        "serverOnly": false
      },
      "wire": [
        "move_in_hard"
      ],
      "server": [
        "move_in_hard"
      ],
      "rpc": [
        "p_move_in_hard"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "flag",
      "operators": [
        "flag"
      ],
      "values": null,
      "note": "a modifier with nothing to modify unless a move-in date is set"
    },
    {
      "key": "keepMine",
      "kind": "flag",
      "layer": "operational",
      "label": "desk_facet_keep_mine",
      "client": {
        "state": "keepMine",
        "url": [
          "keepMine"
        ],
        "serverOnly": true
      },
      "wire": [
        "exposure_keep_mine"
      ],
      "server": [
        "exposure_keep_mine"
      ],
      "rpc": [
        "p_exposure_keep_mine"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "modifier",
      "operators": [
        "modifier"
      ],
      "values": null,
      "note": "only alongside an exposure bound"
    },
    {
      "key": "dateField",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_dates",
      "client": {
        "state": "dateField",
        "url": [
          "dateField"
        ],
        "serverOnly": false
      },
      "wire": [
        "date_field"
      ],
      "server": [
        "date_field"
      ],
      "rpc": [],
      "unit": "client",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "the dimension a date range means; default added"
    },
    {
      "key": "dateRanges",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_dates",
      "client": {
        "state": "dateRanges",
        "url": [
          "dates"
        ],
        "serverOnly": false
      },
      "wire": [
        "dates"
      ],
      "server": [
        "dates"
      ],
      "rpc": [
        "p_dates"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "four date dimensions, each with its own range, combinable (0863)"
    },
    {
      "key": "ageKinds",
      "kind": "set",
      "layer": "intelligence",
      "label": "desk_facet_age",
      "client": {
        "state": "ageKinds",
        "url": [
          "ageKinds"
        ],
        "serverOnly": false
      },
      "wire": [
        "age_kinds"
      ],
      "server": [
        "age_kinds"
      ],
      "rpc": [
        "p_age_kinds"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "which dates the age bound is measured on",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "ageKindsNot",
        "url": [
          "ageKinds_not"
        ],
        "wire": [
          "age_kinds_not"
        ],
        "rpc": [
          "p_age_kinds_not"
        ],
        "unit": "modifier",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit"
      }
    },
    {
      "key": "streetNearbyM",
      "kind": "value",
      "layer": "location",
      "label": "desk_facet_street",
      "client": {
        "state": "streetNearbyM",
        "url": [
          "streets_near"
        ],
        "serverOnly": false
      },
      "wire": [
        "streets_near"
      ],
      "server": [
        null
      ],
      "rpc": [
        "p_street_nearby_m"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "modifier",
      "operators": [
        "modifier"
      ],
      "values": null,
      "note": "radius around a picked street; opt-in"
    },
    {
      "key": "seen",
      "kind": "value",
      "layer": "operational",
      "label": "desk_facet_seen",
      "client": {
        "state": "seen",
        "url": [
          "seen"
        ],
        "serverOnly": false
      },
      "wire": [
        "seen"
      ],
      "server": [
        "seen"
      ],
      "rpc": [
        "p_seen"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": [
        "seen",
        "unseen",
        "seen_by_me",
        "unseen_by_me"
      ],
      "note": "four modes; transport validates membership"
    },
    {
      "key": "agentIds",
      "kind": "set",
      "layer": "provenance",
      "label": "desk_facet_agent",
      "client": {
        "state": "agentIds",
        "url": [
          "agent"
        ],
        "serverOnly": false
      },
      "wire": [
        "agent_ids"
      ],
      "server": [
        null
      ],
      "rpc": [
        "p_party_ids"
      ],
      "unit": "scope",
      "current": false,
      "operator": "include",
      "operators": [
        "include",
        "exclude"
      ],
      "values": null,
      "note": "scope=all only; not serverOnly, see deskFeed",
      "combine": {
        "include": "or",
        "exclude": "not_or",
        "acrossFacets": "and"
      },
      "exclude": {
        "state": "agentIdsNot",
        "url": [
          "agent_not"
        ],
        "wire": [
          "agent_ids_not"
        ],
        "rpc": [
          "p_party_ids_not"
        ],
        "unit": "scope",
        "note": "categorical exclude (B1213): NOT the feature :no operator; unknown follows the unit"
      }
    },
    {
      "key": "featureStates",
      "kind": "set",
      "layer": "characteristics",
      "label": "desk_facet_features",
      "client": {
        "state": "featureStates",
        "url": [
          "feature_states"
        ],
        "serverOnly": true
      },
      "wire": [
        "feature_states"
      ],
      "server": [
        "feature_states"
      ],
      "rpc": [
        "p_feature_states"
      ],
      "unit": "cluster",
      "current": true,
      "operator": "state",
      "operators": [
        "state"
      ],
      "values": null,
      "note": "four-state cycle; see featureStates.js for the cycle itself"
    },
    {
      "key": "featureCodes",
      "kind": "set",
      "layer": "characteristics",
      "label": "desk_facet_features",
      "client": {
        "state": "featureCodes",
        "url": [
          "features"
        ],
        "serverOnly": true
      },
      "wire": [
        "features"
      ],
      "server": [
        "feature_codes"
      ],
      "rpc": [
        "p_feature_codes"
      ],
      "unit": "cluster",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "legacy presence-only list; featureStates supersedes it for panel use",
      "excludeNote": "include-only for now: a search-box pick, not a checkbox facet (B1213 scope)"
    },
    {
      "key": "conditionCodes",
      "kind": "set",
      "layer": "characteristics",
      "label": "desk_facet_condition",
      "client": {
        "state": "conditionCodes",
        "url": [
          "condition"
        ],
        "serverOnly": true
      },
      "wire": [
        "condition"
      ],
      "server": [
        "condition_codes"
      ],
      "rpc": [
        "p_condition_codes"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "renovation + frame rungs, OR-ed across both",
      "excludeNote": "include-only for now: a search-box pick, not a checkbox facet (B1213 scope)"
    },
    {
      "key": "conditionExcludeCodes",
      "kind": "set",
      "layer": "characteristics",
      "label": "desk_facet_condition",
      "client": {
        "state": "conditionExcludeCodes",
        "url": [
          "condition_not"
        ],
        "serverOnly": true
      },
      "wire": [
        "condition_not"
      ],
      "server": [
        "condition_exclude_codes"
      ],
      "rpc": [
        "p_condition_exclude_codes"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "struck rungs; unknowns shelve rather than match",
      "excludeNote": "include-only for now: a search-box pick, not a checkbox facet (B1213 scope)"
    },
    {
      "key": "addedHow",
      "kind": "value",
      "layer": "provenance",
      "label": "desk_facet_added_how",
      "client": {
        "state": "addedHow",
        "url": [
          "added_how"
        ],
        "serverOnly": true
      },
      "wire": [
        "added_how"
      ],
      "server": [
        "added_how"
      ],
      "rpc": [
        "p_added_how"
      ],
      "unit": "cluster",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "crawler | agent; any member of the cluster, like sources"
    },
    {
      "key": "mapPolygon",
      "kind": "value",
      "layer": "location",
      "label": "desk_facet_map_area",
      "client": {
        "state": "mapPolygon",
        "url": [
          "polygon"
        ],
        "serverOnly": true
      },
      "wire": [
        "polygon"
      ],
      "server": [
        "polygon"
      ],
      "rpc": [
        "p_polygon"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "ring as lat,lng;lat,lng;… — the map draws it, the RPC clips to it"
    },
    {
      "key": "intent",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "intent"
      ],
      "server": [
        "intent"
      ],
      "rpc": [
        "p_intent"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "kind",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "kind"
      ],
      "server": [
        "kind"
      ],
      "rpc": [
        "p_kind"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "intents",
      "kind": "set",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "intents"
      ],
      "server": [
        "intents"
      ],
      "rpc": [
        "p_intent"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "audit B04 / core 3832: a multi-pick deal set (one pick keeps the scalar row); rides p_intent as a comma list, OR within the set"
    },
    {
      "key": "kinds",
      "kind": "set",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "kinds"
      ],
      "server": [
        "kinds"
      ],
      "rpc": [
        "p_kind"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "audit B04 / core 3832: a multi-pick type set (one pick keeps the scalar row); rides p_kind as a comma list, OR within the set"
    },
    {
      "key": "rooms_min",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "rooms_min"
      ],
      "server": [
        "rooms_min"
      ],
      "rpc": [
        "p_rooms_min"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "rooms_max",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "rooms_max"
      ],
      "server": [
        "rooms_max"
      ],
      "rpc": [
        "p_rooms_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "bedrooms_min",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "bedrooms_min"
      ],
      "server": [
        "bedrooms_min"
      ],
      "rpc": [
        "p_bedrooms_min"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "bedrooms_max",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "bedrooms_max"
      ],
      "server": [
        "bedrooms_max"
      ],
      "rpc": [
        "p_bedrooms_max"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "num_sets",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "num_sets"
      ],
      "server": [
        "num_sets"
      ],
      "rpc": [
        "p_num_sets"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "F-090: the rooms/bedrooms SET, sent beside the min/max envelope ONLY when the selection has a gap; server-only: hand-written client wire (roomsSet/bedroomsSet), not a deskFilters row. Packed into one jsonb because the RPC is at 100 arguments (FUNC_MAX_ARGS)"
    },
    {
      "key": "sellerKinds",
      "kind": "set",
      "layer": "provenance",
      "label": "desk_facet_seller_whose",
      "client": {
        "state": "sellerKinds",
        "url": [
          "seller"
        ],
        "serverOnly": true
      },
      "wire": [
        "seller_kinds"
      ],
      "server": [
        "seller_kinds"
      ],
      "rpc": [
        "p_num_sets"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": [
        "private_owner",
        "developer",
        "bank",
        "other_company",
        "unknown"
      ],
      "note": "1685 (owner 2026-09-21): SELLER — whose property; core listing_seller_v1. Key of p_num_sets (RPC at 100 arguments). OR with sellerIds"
    },
    {
      "key": "sellerIds",
      "kind": "set",
      "layer": "provenance",
      "label": "desk_facet_seller_whose",
      "client": {
        "state": "sellerIds",
        "url": [
          "seller_id"
        ],
        "serverOnly": true
      },
      "wire": [
        "seller_ids"
      ],
      "server": [
        "seller_ids"
      ],
      "rpc": [
        "p_num_sets"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": null,
      "note": "1685: a named developer or bank (party id) inside the Seller filter; OR with sellerKinds"
    },
    {
      "key": "contactRoles",
      "kind": "set",
      "layer": "provenance",
      "label": "desk_facet_contact",
      "client": {
        "state": "contactRoles",
        "url": [
          "contact"
        ],
        "serverOnly": true
      },
      "wire": [
        "contact_roles"
      ],
      "server": [
        "contact_roles"
      ],
      "rpc": [
        "p_num_sets"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": [
        "owner_direct",
        "agent",
        "company_rep",
        "unknown"
      ],
      "note": "1685: CONTACT — who handles it; an agent is always a representative"
    },
    {
      "key": "agentRepresents",
      "kind": "set",
      "layer": "provenance",
      "label": "desk_facet_agent_represents",
      "client": {
        "state": "agentRepresents",
        "url": [
          "agent_for"
        ],
        "serverOnly": true
      },
      "wire": [
        "agent_represents"
      ],
      "server": [
        "agent_represents"
      ],
      "rpc": [
        "p_num_sets"
      ],
      "unit": "member",
      "current": true,
      "operator": "include",
      "operators": [
        "include"
      ],
      "values": [
        "private_owner",
        "developer",
        "bank",
        "other_company",
        "unknown"
      ],
      "note": "1685: whom the agent acts for; unknown stays unknown, never defaulted to private owner"
    },
    {
      "key": "q",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "q"
      ],
      "server": [
        "q"
      ],
      "rpc": [
        "p_text"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "near_lat",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "near_lat"
      ],
      "server": [
        "near_lat"
      ],
      "rpc": [
        "p_near_lat"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "near_lng",
      "kind": "modifier",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "near_lng"
      ],
      "server": [
        "near_lng"
      ],
      "rpc": [
        "p_near_lng"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "modifier",
      "operators": [
        "modifier"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "near_radius_m",
      "kind": "modifier",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "near_radius_m"
      ],
      "server": [
        "near_radius_m"
      ],
      "rpc": [
        "p_near_radius_m"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "modifier",
      "operators": [
        "modifier"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "date_from",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "date_from"
      ],
      "server": [
        "date_from"
      ],
      "rpc": [
        "p_date_from",
        "p_date_field"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "date_to",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "date_to"
      ],
      "server": [
        "date_to"
      ],
      "rpc": [
        "p_date_to"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "move_in_by",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "move_in_by"
      ],
      "server": [
        "move_in_by"
      ],
      "rpc": [
        "p_move_in_by"
      ],
      "unit": "member",
      "current": true,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server-only: hand-written client state, not yet a deskFilters row"
    },
    {
      "key": "metro_near",
      "kind": "modifier",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "metro_near"
      ],
      "server": [
        "server.js"
      ],
      "rpc": [
        "p_metro_nearby_m"
      ],
      "unit": "modifier",
      "current": false,
      "operator": "modifier",
      "operators": [
        "modifier"
      ],
      "values": null,
      "note": "server.js: rides metro; F-008"
    },
    {
      "key": "claimed",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "claimed"
      ],
      "server": [
        "server.js"
      ],
      "rpc": [
        "p_claimed_by"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server.js ~8302: the Mine lens (0361)"
    },
    {
      "key": "worked",
      "kind": "value",
      "layer": null,
      "label": null,
      "client": null,
      "wire": [
        "worked"
      ],
      "server": [
        "server.js"
      ],
      "rpc": [
        "p_worked_by"
      ],
      "unit": "overlay",
      "current": false,
      "operator": "value",
      "operators": [
        "value"
      ],
      "values": null,
      "note": "server.js ~8305: the Mine lens (0362)"
    }
  ],
  "exclude_naming": {
    "state": "<key>Not",
    "url": "<url>_not",
    "wire": "<wire>_not",
    "rpc": "<p_param>_not",
    "precedent": "condition / condition_not"
  }
}
